import { ServerProduct } from '@/lib/janitsjar/Product';
import StoreStock from '@/cataloguePages/productPageWithVariants/components/StoreStock';
import { StorePickerModalKey } from '@/cataloguePages/productPageWithVariants/modals/StorePicker';
import {
  useCurrentStore,
  useStockByDistance,
} from '@/cataloguePages/productPageWithVariants/helpers';

type Props = {
  product: ServerProduct;
  openModal: (modal: string) => void;
};

export function StoreAvailability({ product, openModal }: Props) {
  const currentStore = useCurrentStore();
  const stockByDistance = useStockByDistance(product);

  if (!currentStore) return null;

  const availableInStores = stockByDistance.filter(
    (store) => store.stock && store.stock.stock > 0
  ).length;

  return (
    <div className="flex flex-col gap-1">
      <span className="cap-xs font-bold">Lagerstatus:</span>
      {stockByDistance.slice(0, 3).map((store) => (
        <StoreStock
          key={store.id}
          storeName={store.name ?? null}
          storeStock={store.stock}
        />
      ))}
      {availableInStores > 0 && (
        <span className="body-xs text-neutral-70">
          På lager i:{' '}
          <button
            onClick={() => {
              openModal(StorePickerModalKey);
            }}
            className="body-link-xs"
          >
            {availableInStores} butikker
          </button>
        </span>
      )}
    </div>
  );
}
